import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import useRequest from "../../../context/useRequest";

const FormCountryCodes = ({ value, onChange }) => {
  const [countryCodes, setCountryCodes] = useState([]);
  const { sendRequest } = useRequest();

  useEffect(() => {
    const fetchCountryCodes = async () => {
      try {
        const response = await sendRequest({
          method: "GET",
          url: "/countryCodes",
        });
        if (response.status && Array.isArray(response.data)) {
          setCountryCodes(response.data);
        }
      } catch (error) {
        console.error("Error fetching country codes:", error);
      }
    };

    fetchCountryCodes();
  }, [sendRequest]);

  const options = countryCodes.map((item) => ({
    value: String(item.phonecode),
    label: `${item.emoji} +${item.phonecode} ${item.name}`,
  }));

  const selectedOption = options.find((opt) => opt.value === String(value)) || null;

  const handleChange = (selected) => {
    const event = {
      target: {
        name: "country_code",
        value: selected?.value || "",
      },
    };
    onChange(event);
  };

  return (
    <div className="w-100">
      <label style={{ marginBottom: "4px", display: "block" }}>
        Country Code <span style={{ color: "red" }}>*</span>
      </label>
      <ReactSelect
        name="country_code"
        value={selectedOption}
        onChange={handleChange}
        options={options}
        placeholder="Select country code..."
        isClearable
        isSearchable // Enables search
        styles={{
          container: (provided) => ({
            ...provided,
            width: "100%",
          }),
          control: (provided) => ({
            ...provided,
            width: "100%",
            height: "48px",
            minHeight: "48px",
            borderRadius: 0,
            boxShadow: "none",
            borderColor: "#ccc",
            '&:hover': {
              borderColor: "#ccc",
            },
          }),
          valueContainer: (provided) => ({
            ...provided,
            height: "48px",
            padding: "0 8px",
          }),
          input: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0,
            color: "black",
          }),
          singleValue: (provided) => ({
            ...provided,
            color: "black",
          }),
          indicatorsContainer: (provided) => ({
            ...provided,
            height: "48px",
          }),
          menu: (provided) => ({
            ...provided,
            width: "100%",
            borderRadius: 0,
          }),
        }}
      />
    </div>
  );
};

export default FormCountryCodes;
